import { render, staticRenderFns } from "./Basin.vue?vue&type=template&id=1fee12cb&scoped=true"
import script from "./Basin.vue?vue&type=script&lang=ts"
export * from "./Basin.vue?vue&type=script&lang=ts"
import style0 from "./Basin.vue?vue&type=style&index=0&id=1fee12cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee12cb",
  null
  
)

export default component.exports